export default "__VITE_ASSET__4c9a5a89__"